/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link } from "react-router-dom";

const Exapandable = ({ data, type }) => {
  const [isActive, setActive] = useState(false);

  const handleHide = () => {
    setActive(!isActive);
  };
  return (
    <>
      <div className="sociology_lists pull-left">
        <span className="lists_heading">{type}</span>
        {data && !data.subject_list && (
          <ul className="refine_lists_topics refine_subject">
            <>
              {(!isActive ? data.slice(0, 5) : data).map((category) =>
                category.series_name ? (
                  <li className="display_block" key={category.series_id}>
                    {/* need to update links */}
                    <Link
                      to={`/serieslanding?subject_slug=${category.subject_slug}&series_slug=${category.series_slug}`}
                    >
                      {category.series_name}
                    </Link>
                  </li>
                ) : (
                  <li className="display_block" key={category.subject_id}>
                    <Link
                      to={`/subjectlanding?subject_slug=${category.subject_slug}`}
                    >
                      {category.subject_name}
                    </Link>
                  </li>
                )
              )}
            </>

            {data.length > 5 && (
              <>
                <li
                  className="more_lists"
                  onClick={handleHide}
                  style={{ cursor: "pointer" }}
                >
                  {!isActive ? <a>More</a> : <a>Less</a>}
                </li>
              </>
            )}
          </ul>
        )}
      </div>
    </>
  );
};

export default Exapandable;
